import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

document.addEventListener("DOMContentLoaded", function () {
  if (document.getElementsByClassName("pdp-slider").length >= 1) {
    var thumbnails = new Splide(".sub-slider", {
      fixedWidth: 75,
      gap: 42,
      rewind: true,
      pagination: false,
      isNavigation: true,
      arrows: false,
      breakpoints: {
        768: {
          gap: 12,
        },
        1024: {
          gap: 24,
        },
      },
    });

    var splide = new Splide(".main-slider", {
      perPage: 1,
      pagination: false,
      type: "fade",
      rewind: true,
      duration: 400,
    });

    splide.sync(thumbnails);
    splide.mount();
    thumbnails.mount();

    var thummies: HTMLCollection =
      document.getElementsByClassName("sub-slider__slide")!;
    if (thummies.length >= 1) {
      var i: number = 0;
      for (i; i < thummies.length; i++) {
        thummies[i].addEventListener("click", function (e) {
          e.preventDefault();
        });
      }
    }
  }
  if (document.getElementsByClassName('splide-slider')) {
    var sliders = document.querySelectorAll('.splide-slider');
    sliders.forEach(function (slider) {
      new Splide(slider as HTMLElement, {
        type: 'loop',
        drag: 'free',
        autoplay: true,
        pagination: false,
        trimSpace: true,
        arrows: false,
        snap: false,
        autoWidth: false,
        gap: '20px',
        autoScroll: {
          speed: .4,
          pauseOnHover: false,
          pauseOnFocus: false,
        },
      }).mount({ AutoScroll });

      setTimeout(() => {
        const slides = slider.querySelectorAll('.splide__slide');
        slides.forEach(function (slide) {
          (slide as HTMLElement).style.width = '';
        });
      }, 100);
    });
  }
  if (document.getElementsByClassName('splide-header')) {
    var sliders = document.querySelectorAll('.splide-header');
    sliders.forEach(function (slider) {
      const instance = new Splide(slider as HTMLElement, {
        type: 'fade',
        rewind: true,
        perPage: 1,
        autoplay: true,
        pagination: false,
        trimSpace: true,
        arrows: false,
        autoWidth: true,
        speed: 0,
        updateOnMove: true,
      }).mount();
      instance.on('moved', function (newIndex) {
        const slides = instance.Components.Elements.slides;
        slides.forEach((slide, index) => {
          slide.classList.remove('is-next', 'is-prev');
          if (index === (newIndex + 1) % slides.length) {
            slide.classList.add('is-next');
          }
          if (index === (newIndex - 1 + slides.length) % slides.length) {
            slide.classList.add('is-prev');
          }
        });
      });
    });
  }

  if (document.getElementsByClassName("splide-product-main").length >= 1) {
    var thumbnails = new Splide(".splide-product-sub", {
      fixedWidth: '100px',
      fixedHeight: '100px',
      gap: 12,
      rewind: false,
      type: "slide",
      pagination: false,
      isNavigation: true,
      arrows: true,
      breakpoints: {
        768: {
          gap: 12,
        },
        1024: {
          gap: 24,
        },
      },
    });

    var splide = new Splide(".splide-product-main", {
      perPage: 1,
      pagination: false,
      type: "fade",
      rewind: true,
      duration: 400,
      autoHeight: true,
      arrows: false,
      // height: "20rem",
    });

    splide.sync(thumbnails);
    splide.mount();
    thumbnails.mount();

    var thummies: HTMLCollection =
      document.getElementsByClassName("splide-product-sub__slide")!;
    if (thummies.length >= 1) {
      var i: number = 0;
      for (i; i < thummies.length; i++) {
        thummies[i].addEventListener("click", function (e) {
          e.preventDefault();
        });
      }
    }
  }
});
